/* eslint-disable no-unused-vars */
import { Form, Input } from 'antd';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import DokanIcons from '../icon/DokanIcons';

const DokanTextInputField = ({
    placeholder,
    disableMargin,
    styleClasses,
    isBorder,
    isInputDisable,
    hasIcon,
    FormInputName,
    FormInputLabel,
    FormInputRules,
    FormInputValue,
    onValueChange,
    children,
}) => {
    const form = Form.useForm();
    const [inputState, setInputState] = useState(isInputDisable);
    const handleInput = () => {
        setInputState((prevState) => !prevState);
        // eslint-disable-next-line no-param-reassign
        isInputDisable = inputState;
    };

    const changeInputField = (name, value) => {
        onValueChange(name, value);
    };

    const getInputData = useSelector((state) => state.products.productInputData);
    const InputData = { ...getInputData };
    // console.log(InputData[FormInputName]);
    const setInputData = InputData[FormInputName];

    return (
        <Form.Item name={FormInputName} label={FormInputLabel} rules={FormInputRules}>
            <div className={`${hasIcon ? 'flex flex-grow-6 items-center' : ''}`}>
                <div className={`${hasIcon ? 'flex-grow-4' : ''}`}>
                    <Input
                        className={`${styleClasses} ${!disableMargin && 'mt-20px'}`}
                        placeholder={placeholder}
                        bordered={!isBorder}
                        disabled={inputState}
                        onChange={(e) => changeInputField(FormInputName, e.target.value)}
                        value={setInputData}
                    />
                </div>
                {hasIcon && (
                    <div className={`${hasIcon ? 'flex-grow-2 pt-5 items-baseline' : ''}`}>
                        <button type="button" onClick={handleInput}>
                            {inputState ? (
                                <DokanIcons icon="#inline_edit" size={3} />
                            ) : (
                                <span>Done</span>
                            )}
                        </button>
                    </div>
                )}
            </div>
            <div>{children}</div>
        </Form.Item>
    );
};

export default DokanTextInputField;
